import React from "react";
import { Container } from "reactstrap";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { UnderConstruction } from "../../../Component/UnderConstruction/UnderConstruction";

const MadinaReceptionAndArrivalReports = () => {
  const { t } = useTranslation();

  return (
    <div>
      <PageHeader title={t("MADINA_RECEPTION_AND_ARRIVAL_REPORTS")} sticky={false} />
      <Container fluid>
        <Row justify="center" style={{ marginTop: "60px" }}>
          <Col xs={24} sm={20} md={16} lg={12} xl={10}>
            <UnderConstruction />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default MadinaReceptionAndArrivalReports;
